'use strict';

var createAsyncLocalStorage = require('./defaults/asyncLocalStorage');

module.exports.persistStore = require('./persistStore');
module.exports.autoRehydrate = require('./autoRehydrate');
module.exports.getStoredState = require('./getStoredState');
module.exports.storages = {
  asyncLocalStorage: createAsyncLocalStorage('local'),
  asyncSessionStorage: createAsyncLocalStorage('session')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/lib/index.js
 ** module id = 708
 ** module chunks = 0
 **/